import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  createHint: {
    method: 'POST',
    url: `${configs.baseUrl}/api/hint/`,
  },
  patchHintById: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/hint/{hintId}`,
  },
  deleteHint: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/hint/{hintId}`,
  },
  uploadHintImage: {
    method: 'POST',
    url: `${configs.baseUrl}/api/hint/image/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const createHint = async (payload) => {
  const res = await resource.createHint(payload)
  return res.body
}

const patchHintById = async (hintId, payload) => {
  const res = await resource.patchHintById({ hintId }, payload)
  return res.body.hint
}

const deleteHint = async (hintId, payload) => {
  const res = await resource.deleteHint({ hintId }, payload)
  return res.body
}

const uploadHintImage = async (payload) => {
  return resource.uploadHintImage(payload)
}

export default {
  initResource,
  createHint,
  patchHintById,
  deleteHint,
  uploadHintImage,
}
